import React from 'react';
import RightImage from '../../assets/images/requests/Right.png';
import WrongImage from '../../assets/images/requests/Wrong.png';
import styles from './Tips.module.scss';
import icons from '../../assets/icons';
import cx from 'classnames';

function Tips({ title, text, showImages = true, marginTop = 1, customImages }) {
  const { RightCheckIcon, WrongCrossIcon } = icons;
  return (
    <div className={styles.wrapper} style={{ marginTop: `${marginTop}rem` }}>
      <h5 className="py-3">
        Tips for <span className={styles.title}>{title}</span>
      </h5>
      {showImages && (
        <div className="d-flex flex-columns">
          <div
            className={cx(
              'd-flex flex-column gap-3 align-items-center w-50',
              styles.RightCheckIcon
            )}>
            <RightCheckIcon />
            <img src={RightImage} />
          </div>
          <div
            className={cx(
              'd-flex flex-column gap-3 align-items-center w-50',
              styles.WrongCrossIcon
            )}>
            <WrongCrossIcon />
            <img src={WrongImage} />
          </div>
        </div>
      )}

      {customImages ? (
        <div className={cx("d-flex gap-2 pb-3", styles.customImages)}>
          {customImages.map((_item, _index) => (
            <img key={_index} src={_item} style={{width: `${100 / customImages.length}%`}}/>
          ))}
        </div>
      ) : null}
      <span className={styles.tipText}>{text}</span>
    </div>
  );
}

export default Tips;
